/**
 * Build-time feature gates.
 *
 * `environmentScanEnabled` — when false (the current deployment), the app is
 * form-only: the SharePoint site picker / environment scan and the Deep
 * Analysis report are hidden (the components and routes remain in code, they
 * are simply not surfaced). The backend enforces the same gate via the
 * `ENVIRONMENT_SCAN_ENABLED` setting. Defaults to false when the env var is
 * absent, so the safe (form-only) path is the default.
 */
export const environmentScanEnabled =
  import.meta.env.VITE_ENVIRONMENT_SCAN_ENABLED === 'true';
